<template>
  <generic-container
    icon="list"
    :title="$t('exchange list')"
    v-bind:show_plus="false"
    :show_refresh="true"
    @refresh="refresh_data"
    :configurable="true"
    v-bind:configure_modal="configure_modal"
  >
    <table
      class="ui blue celled striped selectable table"
      ref="table"
      style="width:100%"
    >
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("email") }}</th>
          <th>{{ $t("store") }}</th>
          <th>{{ $t("status") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <exchange-modal ref="exchange_modal" @done="refresh_data" />
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import {
  local_api,
  error_toast,
  init_json_local_data_datables,
  enterprise_setup,
} from "@/utils";
import ExchangeModal from "./exchange_modal/Index";
import filters from "@/filters";

export default {
  name: "NworkforceRedeemIndex",
  components: { GenericContainer, ExchangeModal },
  data() {
    return {
      configure_modal: ConfigureModal,
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    decode_status(status_code) {
      let vm = this;
      switch (status_code) {
        case "A":
          return `<i class="green check icon"></i>${vm.$t("approved")}`;
        case "D":
          return `<i class="red remove icon"></i>${vm.$t("denied")}`;
        case "R":
          return vm.$t("requested");
        default:
          return status_code;
      }
    },
    refresh_data() {
      let vm = this;
      local_api(this, "post", "/nworkforce_exchange/exchange/do-get-list")
        .then((list) => {
          if (list) {
            vm.list = list;
            let columns = [
              {
                data: function(row) {
                  // console.log(row);
                  return filters.formatDate(
                    row.create_date,
                    vm.enterprise_setup.detailed_date_format,
                  );
                },
              },
              {
                data: function(row) {
                  // console.log(row);
                  return row.setup.name;
                },
              },
              {
                data: function(row) {
                  // console.log(row);
                  return row.setup.email;
                },
              },
              {
                data: function(row) {
                  // console.log(row);
                  return row.nvb_store.setup.name;
                },
              },
              {
                data: function(row) {
                  // console.log(row);
                  return vm.decode_status(row.status_code);
                },
              },
            ];

            let onSelect = (data) => {
              vm.$refs.exchange_modal.show(data);
            };

            let onCreatedRow = (/* tr, element */) => {
              // if (element.status_code == "A")
              //   window.jQuery(tr).addClass("positive");
              // if (element.status_code == "D")
              //   window.jQuery(tr).addClass("negative");
            };
            let onPageChanged = () => {};

            init_json_local_data_datables(
              vm,
              vm.$refs.table,
              vm.list,
              columns,
              onSelect,
              onCreatedRow,
              onPageChanged,
            );
          }
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    let vm = this;

    vm.refresh_data();
  },
};
</script>
